import { createClasses } from '@/theme/create-classes';

// ----------------------------------------------------------------------

export const logoClasses = {
  root: createClasses('logo__root'),
};
